import EventEmitter from 'eventemitter3';

function getHeadings(element) {
    return getElements(element, 'h2, h3');
}

function getElements(root, type) {
    const elements = root.querySelectorAll(type);

    return Array.from(elements)
        .map(el => {
            const idel = el.querySelector('span[id]');
            if (idel) {
                return {
                    id: idel.getAttribute('id'),
                    text: el.innerText,
                    ref: el,
                    level: typeToNum(el.nodeName),
                    type: el.nodeName
                };
            }

            return null
        })
        .filter(el => el);
}

function typeToNum(type) {
    switch (type) {
        case 'H1':
            return 0;
        case 'H2':
            return 1;
        case 'H3':
            return 2;
        case 'H4':
            return 3;
        case 'H5':
            return 4;
        case 'H6':
            return 5;
        default:
            return 6;
    }
}

function createElements(headings) {

    const root = document.querySelector('[data-toc]');

    let lastElement = null;
    let lastLevels = {};

    for (let i = 0; i < headings.length; i++) {
        const heading = headings[i];

        if (!lastElement) {
            lastElement = root;
        } else if (typeToNum(lastElement.nodeName) >= heading.level) {
            // Find parent
            let parentLevel = heading.level - 1;
            let parent = null;

            while (!parent && parentLevel >= 0) {
                parent = lastLevels[parentLevel];
                parentLevel--;
            }

            if (parent) {
                lastElement = parent;
            } else {
                lastElement = root;
            }
        }

        let next = document.createElement('div');
        next.classList.add('toc__level');
        next.classList.add('toc__level--' + heading.level);

        let content = document.createElement('div');
        content.classList.add('toc__content');
        next.appendChild(content);

        let link = document.createElement('a');
        link.setAttribute('href', `#${heading.id}`);
        link.classList.add('toc__link');
        link.classList.add('toc__link--' + heading.type);
        link.innerText = heading.text;

        content.appendChild(link);

        let children = lastElement.querySelector('.toc__children');

        if (heading.level === 1 && children && !heading.ref.closest('.about-publication')) {
            let expander = document.createElement('button');
            expander.classList.add('toc__expander');
            content.appendChild(expander);
        }

        if (!children) {
            children = document.createElement('div');
            children.classList.add('toc__children');
            lastElement.appendChild(children);
        }

        children.appendChild(next);
        lastElement = next;
        lastLevels[heading.level] = next;
    }
}

export default class Toc extends EventEmitter {

    rootElement = null;

    setup() {
        this.rootElement = document.querySelector('#content');
        const headings = getHeadings(this.rootElement);
        createElements(headings);
        this.setupListeners(this.rootElement);
    }

    setupListeners(root) {
        let buttons = root.querySelectorAll('.toc__expander');
        let tocTopLinks = root.querySelectorAll(
            '.toc > .toc__children > .toc__level > .toc__content .toc__link'
        );

        const width = window.innerWidth;
        const breakMobile = 800;

        Array.from(buttons).forEach(button => {
            button.addEventListener('click', (e) => {
                let parent = e.target.parentElement.closest('.toc__level');
                let isOpen = parent.classList.contains('toc__level--expanded');

                this.resetExpansion();
                this.resetActive();

                if (!isOpen) {
                    parent.classList.add('toc__level--expanded');
                }
            });
        });

        let toc = root.querySelector('[data-toc]');

        toc.addEventListener('click', e => {
            try {
                if (e.target.classList.contains('toc__link') && width <= breakMobile) {
                    this.emitClose();
                }
            } catch (e) {
            }
        });

        tocTopLinks.forEach((link) => {
            link.addEventListener('click', (e) => {

                this.resetActive();

                e.target.closest('.toc__level').classList.add(
                    'toc__level--active'
                );

                if (!e.target.closest('.toc__level--expanded')) {
                    if (this.resetExpansion() > 0) {
                        e.target.scrollIntoView({block: "center"});
                    }
                }
            });
        });
    }

    resetActive(){
        this.rootElement.querySelectorAll(
            '.toc__level'
        ).forEach(
            (level) => {
                level.classList.remove('toc__level--active');
            }
        );
    }

    resetExpansion() {
        let expanded = this.rootElement.querySelectorAll('.toc__level--expanded');
        let expandedLength = expanded.length;

        try {
            Array.from(expanded).forEach(element => element.classList.remove('toc__level--expanded'));
        } catch (error) {
        }

        return expandedLength;
    }

    emitClose() {
        this.emit('close');
    }
}
